/**
 * Loader component
 * ----------------
 */

/* Imports */

import React, { useLayoutEffect, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { publish } from "../../base/pub-sub";
import globals from "../../base/variables";
import { GlobalStyles } from "../../base/styles/global.module.scss";
import { Loader } from "./styles.module.scss";

/* Component */

const LoaderComponent = () => {
  const [hide, setHide] = useState(false);
  const [js, setJs] = useState("no-js");

  /* Js enabled */

  useEffect(() => {
    setJs("js");
  }, []);

  useLayoutEffect(() => {
    /* Check if IntersectionObserver is supported (set here so accurate in other components) */

    const { body } = document;

    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      body.classList.add("io");
      globals.ioSupported = true;
    } else {
      body.classList.add("no-io");
    }

    /* Check if reduce motion (set here so accurate in other components) */

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (!mediaQuery || mediaQuery.matches) globals.reduceMotion = true;

    /* Hide when page fully loaded */

    setTimeout(() => {
      setHide(true);
      publish("loaderDone");
      globals.loaderDone = true;
    }, 300);
  }, []);

  return (
    <>
      <Helmet>
        <html lang="en" className={`lc ${GlobalStyles} ${js}`} />
      </Helmet>
      <div className={`${Loader} lc-loader`} data-hide={hide.toString()}>
        <div />
      </div>
    </>
  );
};

/* Export */

export default LoaderComponent;
